<template>
  <form @submit.prevent="submit" class="space-y-6">
    <ErrorSummary :response-status="responseStatus" />

    <div>
      <label for="email" class="block text-sm font-medium text-clay-950">
        Email address
      </label>
      <div class="mt-1">
        <input
          v-model="email"
          id="email"
          name="email"
          type="email"
          autocomplete="email"
          required
          class="block w-full rounded-lg border border-transparent shadow-sm ring-1 ring-black/10 px-[calc(theme(spacing.2)-1px)] py-[calc(theme(spacing[1.5])-1px)] text-clay-950 sm:text-sm/6 data-[focus]:outline data-[focus]:outline-2 data-[focus]:-outline-offset-1 data-[focus]:outline-black"
        />
      </div>
    </div>

    <div class="space-y-1">
      <label for="password" class="block text-sm font-medium text-clay-950">
        Password
      </label>
      <div class="mt-1">
        <input
          v-model="password"
          id="password"
          name="password"
          type="password"
          autocomplete="current-password"
          required
          class="block w-full rounded-lg border border-transparent shadow-sm ring-1 ring-black/10 px-[calc(theme(spacing.2)-1px)] py-[calc(theme(spacing[1.5])-1px)] text-clay-950 sm:text-sm/6 data-[focus]:outline data-[focus]:outline-2 data-[focus]:-outline-offset-1 data-[focus]:outline-black"
        />
      </div>
    </div>

    <div class="flex items-center justify-between">
      <div class="flex items-center">
        <input
          v-model="rememberMe"
          id="remember-me"
          name="remember-me"
          type="checkbox"
          class="w-4 h-4 rounded border-clay-300 text-clay-800 focus:ring-clay-500"
        />
        <label for="remember-me" class="block ml-2 text-sm text-clay-900">
          Remember me
        </label>
      </div>

      <div class="text-sm">
        <a
          href="/forgot-password"
          class="font-medium text-clay-800 hover:text-clay-900"
        >
          Forgot your password?
        </a>
      </div>
    </div>

    <div>
      <SaButton
        type="submit"
        @click.prevent="submit"
        :loading="isSubmitting"
        variant="primary"
      >
        <template #loading>
          Signing in...
        </template>
        Sign in
      </SaButton>
    </div>
  </form>
</template>

<script lang="ts" setup>
import { defineProps, ref } from "vue";
import { client } from "@/shared";
import { Authenticate } from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import SaButton from "@/main/components/SaButton.vue";

const props = defineProps<{
  redirect?: string;
}>();

const email = ref("");
const password = ref("");
const rememberMe = ref(false);
const responseStatus = ref(null);

const isSubmitting = ref(false);
const submit = async () => {
  isSubmitting.value = true;
  const redirect = props.redirect || "/";

  try {
    await client.post(
      new Authenticate({
        userName: email.value,
        password: password.value,
        rememberMe: rememberMe.value,
        provider: "credentials",
        meta: { redirect }
      })
    );
    window.location.href = redirect;
  } catch (e: any) {
    responseStatus.value = e.responseStatus || {
      errorCode: "Unknown",
      message: "An error occurred"
    };
  } finally {
    isSubmitting.value = false;
  }
};
</script>
